import api from "./api";

export const ADMIN_GET_USERS_REQUEST = 'admin/ADMIN_GET_USERS/REQUEST';
export const ADMIN_GET_USERS_SUCCESS = 'admin/ADMIN_GET_USERS/SUCCESS';
export const ADMIN_GET_USERS_FAILURE = 'admin/ADMIN_GET_USERS/FAILURE';
export const ADMIN_SAVE_USER_REQUEST = 'admin/ADMIN_SAVE_USER/REQUEST';
export const ADMIN_SAVE_USER_SUCCESS = 'admin/ADMIN_SAVE_USER/SUCCESS';
export const ADMIN_SAVE_USER_FAILURE = 'admin/ADMIN_SAVE_USER/FAILURE';
export const ADMIN_CREATE_USER_REQUEST = 'admin/ADMIN_CREATE_USER/REQUEST';
export const ADMIN_CREATE_USER_SUCCESS = 'admin/ADMIN_CREATE_USER/SUCCESS';
export const ADMIN_CREATE_USER_FAILURE = 'admin/ADMIN_CREATE_USER/FAILURE';

export const ADMIN_GET_PERMISSIONS_REQUEST = "admin/ADMIN_GET_PERMISSIONS/REQUEST";
export const ADMIN_GET_PERMISSIONS_SUCCESS = "admin/ADMIN_GET_PERMISSIONS/SUCCESS";
export const ADMIN_GET_PERMISSIONS_FAILURE = "admin/ADMIN_GET_PERMISSIONS/FAILURE";

export const ADMIN_GET_ACTIVITIES_REQUEST = 'admin/ADMIN_GET_ACTIVITIES/REQUEST';
export const ADMIN_GET_ACTIVITIES_SUCCESS = 'admin/ADMIN_GET_ACTIVITIES/SUCCESS';
export const ADMIN_GET_ACTIVITIES_FAILURE = 'admin/ADMIN_GET_ACTIVITIES/FAILURE';
export const ADMIN_SAVE_ACTIVITY_REQUEST = 'admin/ADMIN_SAVE_ACTIVITY/REQUEST';
export const ADMIN_SAVE_ACTIVITY_SUCCESS = 'admin/ADMIN_SAVE_ACTIVITY/SUCCESS';
export const ADMIN_SAVE_ACTIVITY_FAILURE = 'admin/ADMIN_SAVE_ACTIVITY/FAILURE';
export const ADMIN_CREATE_ACTIVITY_REQUEST = 'admin/ADMIN_CREATE_ACTIVITY/REQUEST';
export const ADMIN_CREATE_ACTIVITY_SUCCESS = 'admin/ADMIN_CREATE_ACTIVITY/SUCCESS';
export const ADMIN_CREATE_ACTIVITY_FAILURE = 'admin/ADMIN_CREATE_ACTIVITY/FAILURE';

export function loadUsers() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.loadUsers()
                .then(
                    data => {
                        dispatch(success(data));
                        resolve(data);
                    },
                    error => {
                        handleErrorCode(error, dispatch);
                        dispatch(failure(error));
                        resolve(error);
                    }
                );
        });
    };

    function request() {
        return {type: ADMIN_GET_USERS_REQUEST}
    }

    function success(data) {
        return {type: ADMIN_GET_USERS_SUCCESS, data}
    }

    function failure(error) {
        return {type: ADMIN_GET_USERS_FAILURE, error}
    }
}

export function saveUser(user) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.saveUser(user)
                .then(
                    _ => {
                        dispatch(loadUsers());
                        dispatch(success());
                        resolve();
                    },
                    error => {
                        handleErrorCode(error, dispatch);
                        dispatch(failure(error));
                        resolve(error);
                    }
                );
        });
    };

    function request() {
        return {type: ADMIN_SAVE_USER_REQUEST}
    }

    function success(users) {
        return {type: ADMIN_SAVE_USER_SUCCESS, users}
    }

    function failure(error) {
        return {type: ADMIN_SAVE_USER_FAILURE, error}
    }
}

export function createUser(user) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.createUser(user)
                .then(
                    _ => {
                        dispatch(loadUsers());
                        dispatch(success());
                        resolve();
                    },
                    error => {
                        handleErrorCode(error, dispatch);
                        dispatch(failure(error));
                        resolve(error);
                    }
                );
        });
    };

    function request() {
        return {type: ADMIN_CREATE_USER_REQUEST}
    }

    function success(users) {
        return {type: ADMIN_CREATE_USER_SUCCESS, users}
    }

    function failure(error) {
        return {type: ADMIN_CREATE_USER_FAILURE, error}
    }
}

export function loadActivities() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.loadActivities()
                .then(
                    activities => {
                        dispatch(success(activities));
                        resolve(activities);
                    },
                    error => {
                        handleErrorCode(error, dispatch);
                        dispatch(failure(error));
                        resolve(error);
                    }
                );
        });
    };

    function request() {
        return {type: ADMIN_GET_ACTIVITIES_REQUEST}
    }

    function success(activities) {
        return {type: ADMIN_GET_ACTIVITIES_SUCCESS, activities}
    }

    function failure(error) {
        return {type: ADMIN_GET_ACTIVITIES_FAILURE, error}
    }
}

export function loadPermissions() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.loadPermissions()
                .then(
                    permissions => {
                        dispatch(success(permissions));
                        resolve(permissions);
                    },
                    error => {
                        handleErrorCode(error, dispatch);
                        dispatch(failure(error));
                        resolve(error);
                    }
                );
        });
    };

    function request() {
        return { type: ADMIN_GET_PERMISSIONS_REQUEST };
    }

    function success(permissions) {
        return {
            type: ADMIN_GET_PERMISSIONS_SUCCESS,
            permissions
        };
    }

    function failure(error) {
        return {
            type: ADMIN_GET_PERMISSIONS_FAILURE,
            error
        };
    }
}

export function saveActivity(activity) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.saveActivity(activity)
                .then(
                    _ => {
                        dispatch(loadActivities());
                        dispatch(success());
                        resolve();
                    },
                    error => {
                        handleErrorCode(error, dispatch);
                        dispatch(failure(error));
                        resolve(error);
                    }
                );
        });
    };

    function request() {
        return {type: ADMIN_SAVE_ACTIVITY_REQUEST}
    }

    function success() {
        return {type: ADMIN_SAVE_ACTIVITY_SUCCESS}
    }

    function failure(error) {
        return {type: ADMIN_SAVE_ACTIVITY_FAILURE, error}
    }
}

export function createActivity(user) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.createActivity(user)
                .then(
                    _ => {
                        dispatch(loadUsers());
                        dispatch(success());
                        resolve();
                    },
                    error => {
                        handleErrorCode(error, dispatch);
                        dispatch(failure(error));
                        resolve(error);
                    }
                );
        });
    };

    function request() {
        return {type: ADMIN_CREATE_ACTIVITY_REQUEST}
    }

    function success() {
        return {type: ADMIN_CREATE_ACTIVITY_SUCCESS}
    }

    function failure(error) {
        return {type: ADMIN_CREATE_ACTIVITY_FAILURE, error}
    }
}

function handleErrorCode(error, dispatch) {
    if (error === 401) {
        //dispatch(logout());
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Admin/reducer/actions.js